const adaptSSAGSearch = require('../../../shared/adaptSSAGSearch');

export default adaptSSAGSearch;
